export default __webpack_public_path__ + "static/media/instagram-line.bd46d97f.svg";